import { Button, Callout, Dialog, EmptyState, Icon, Icons, Intent, ListItem, QueryList, Spinner, Tag } from "construct-ui";
import userSearchModal from "../../models/common/user-search.modal";
import siteModel from "../../models/site/site.model";
import ViewBase from "../../views/view-base.view";

export default function SelectSiteGroupComponent() {
  ViewBase.call(this);

  const DEFAULT_ONCHANGE = (selecteditems) => { console.log('SelectSiteGroupComponent: onChange(selectedItems)') };
  const TITLE_SEPARATOR = ', ';

  let searchable = true;
  let filterable = false;
  let isOpen = false;
  let isSearching = false;
  let itemList;
  let selectedItemList = [];
  let filter = { siteGroupName: '', countryCode: '' };
  let siteGroupNamePromise = null;

  let clearSelectedItemList = (onChange) => () => {
    selectedItemList = [];
    onChange(selectedItemList);
  }

  let search = () => {
    isSearching = true;
    userSearchModal.getStoreGroupList(
      (result) => {
        itemList = [];
        if (result) {
          result.map(e => {
            itemList.push({ ...e });
          });
        }
        isSearching = false;
      },
      (error) => {
        isSearching = false;
        this.handleError(error);
      },
      filter
    )
  }

  let clearSearchFilter = () => {
    filter.siteGroupName = '';
    itemList = undefined;
  }

  function renderItem(item, index) {
    return m(ListItem, {
      allowOnContentClick: true,
      label: item.name,
      selected: (selectedItemList.findIndex(i => i.code === item.code) > -1),
    })
  }

  const handleSelect = (onChange) => (item) => {
    if (item.code == "") {
      if (selectedItemList.length > 0) {
        selectedItemList.splice(0, selectedItemList.length);
      } else {
        itemList.map((item, index) => {
          if (index > 0 && selectedItemList.findIndex(i => i.code === item.code) < 0) {
            selectedItemList.push(item);
          }
        });
      }
    } else if (selectedItemList.findIndex(i => i.code === item.code) > -1) {
      selectedItemList.splice(selectedItemList.findIndex(i => i.code === item.code), 1);
    } else {
      selectedItemList.push(item);
    }

    onChange(selectedItemList);
  }

  function renderSelectedLabel(item) {
    if (item.name) {
      return item.name;
    }

    let itemName = itemList?.find(i => i.code === item.code)?.name;
    if (itemName) {
      item.name = itemName;
      return itemName;
    }

    return '';
  }

  function getMissingSiteGroupNames() {
    let selectedCodesWithMissingName = selectedItemList.filter(i => !i.name).map(i => i.code);

    if (!(selectedCodesWithMissingName?.length > 0) && siteGroupNamePromise) return;

    siteGroupNamePromise = siteModel.getSiteGroupsBySiteGroupCodes(selectedCodesWithMissingName)
      .then((result) => {
        result?.map((sg) => {
          let selectedItem = selectedItemList.find((i) => i.code === sg.code)
          if (selectedItem) {
            selectedItem.name = sg.name;
          }
        });
      })
      .catch((error) => {
        this.handleError(error)
      })
      .finally(() => { siteGroupNamePromise = null });
  }

  let renderLabel = (_selectedItemList) => {
    return (_selectedItemList && _selectedItemList.length > 0)
      ? _selectedItemList.length + ' ' + this.getText("LT00000308", "item(s) selected")
      : ''
  }

  const renderTitle = _selectedItemList => {
    return (_selectedItemList && _selectedItemList.length > 0)
      ? _selectedItemList.map(siteGroups => siteGroups.name).join(TITLE_SEPARATOR)
      : ''
  }

  const readOnly = (event) => {
    event.preventDefault();
    event.stopImmediatePropogation();
  }


  let Content = {
    view: ({ attrs: { disabled, onChange } }) => {
      return m('.container',
        // Selected section
        m('.d-flex.justify-content-between.gap-2',
          m('.d-flex.gap-2',
            m('label.form-label', this.getText("LT00000343", "Selected items")),
            (selectedItemList && selectedItemList.length > 0)
              ? [m('span', ':'), m('span', selectedItemList.length + ' ' + this.getText("LT00000344", "items"))]
              : ''
          ),
          m('.d-flex.gap-2',
            m('a.btn.btn-link.p-0', {
              onclick: clearSelectedItemList(onChange)
            }, this.getText("LT00000345", "Clear all")),
          )
        ),
        m('.card.mb-3',
          m('.card-body.overflow-auto', { style: 'min-height: 51px; max-height: 82px;' },
            m('.d-flex.flex-wrap.gap-1',
              (selectedItemList && selectedItemList.length > 0)
                ? selectedItemList.map(i => [
                  m(Tag, {
                    class: 'm-0',
                    label: renderSelectedLabel(i),
                    onRemove: e => {
                      let idx = selectedItemList.findIndex(s => s.code === i.code);
                      if (idx > -1) {
                        selectedItemList.splice(idx, 1);
                        onChange(selectedItemList);
                      }
                    }
                  })
                ])
                : m(EmptyState, {
                  content: this.getText("LT00000318", "No items selected. Please search and select from the section below."),
                  style: 'color: var(--is-inactive-gray)',
                })
            ),
          )
        ),
        // Search section
        m('.card.mb-3',
          m('.card-body',
            m('.row.g-4',
              searchable && m('.col-12',
                m('.d-flex.flex-wrap.justify-content-end.gap-2',
                  m('.flex-grow-1', { style: 'min-width: 60%;' },
                    m('input.form-control[type=text]', {
                      placeholder: this.getText("LT00000319", "Site Group Name"),
                      onchange: e => { filter.siteGroupName = e.target.value },
                      value: filter.siteGroupName,
                    }),
                  ),
                  m('.d-flex.gap-2',
                    m(Button, {
                      label: this.getText("LT00000001", "Search"),
                      intent: Intent.PRIMARY,
                      loading: isSearching,
                      onclick: search,
                    }),
                    m(Button, {
                      label: this.getText("LT00000031", "Clear"),
                      intent: Intent.PRIMARY,
                      outlined: true,
                      onclick: clearSearchFilter,
                    }),
                  ),
                ),
              ),
              m('.col-12.position-relative', { style: 'min-height: 180px;' },
                itemList && itemList.length > 0
                  ? m(QueryList, {
                    filterable: filterable,
                    items: itemList,
                    itemRender: renderItem,
                    itemListPredicate: (query, items) => items.filter(i => i.name.toLowerCase().includes(query.toLowerCase())),
                    onSelect: handleSelect(onChange),
                    listAttrs: {
                      style: 'height: calc(100vh - 520px);'
                    }
                  })
                  : m(EmptyState, {
                    icon: Icons.ARCHIVE,
                    content: this.getText("LT00000317", "No results found"),
                    fill: true,
                    style: 'color: #B5B5B5',
                  }),
                isSearching &&
                m(Spinner, {
                  active: isSearching,
                  background: true,
                  fill: true,
                  size: 'xl',
                })
              )
            )
          )
        ),
        itemList && itemList.length > 199 &&
        m(Callout, {
          content: this.getText("LT00000320", "Only top 200 records are shown due to large result set"),
          icon: Icons.ALERT_CIRCLE,
          intent: Intent.WARNING,
        })
      )
    }
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.selectedItems) {
        selectedItemList = vnode.attrs.selectedItems;
        getMissingSiteGroupNames();
      }

      filter.countryCode = vnode.attrs.countryCode ?? '';
      searchable = vnode.attrs.searchable ?? searchable;

      // Only allow external list if not searchable
      if (!searchable) {
        itemList = vnode.attrs.items ?? []
      }

      filterable = vnode.attrs.filterable ?? filterable;

      search();
    },
    onupdate: (vnode) => {
      // Only allow external list if not searchable
      if (!searchable) {
        itemList = vnode.attrs.items ?? itemList ?? [];
      }

      if ((typeof vnode.attrs.countryCode === 'string' || vnode.attrs.countryCode instanceof String)
        && filter.countryCode !== vnode.attrs.countryCode) {
        filter.countryCode = vnode.attrs.countryCode;
        search();
      }

      selectedItemList = vnode.attrs.selectedItems ?? selectedItemList;
      //getMissingSiteGroupNames();
    },
    view: ({ attrs: {
      id = null,
      required = false,
      disabled = false,
      placeholder = null,
      selectedItems = [],
      onChange = DEFAULT_ONCHANGE
    } }) => {
      return [
        m('.select-input-component.d-flex.justify-content-between.align-items-center.form-control.form-control-bg', {
          class: disabled ? 'disabled ' : '',
          onclick: () => {
            if (!disabled) {
              isOpen = !isOpen;
            }
          }
        },
          m('input.flex-fill.text-start.ps-0', {
            id,
            disabled,
            required,
            type: 'text',
            placeholder: placeholder || this.getText("LT00000201", "Please select"),
            oninput: readOnly,
            style: {
              width: 'inherit',
              'overflow-x': 'hidden',
              'text-overflow': 'ellipsis',
              border: 'none',
              background: 'transparent'
            },
            value: renderLabel(selectedItems),
            title: renderTitle(selectedItems)
          }),
          m(Icon, { name: Icons.LIST, intent: Intent.PRIMARY })
        ),
        isOpen &&
        m(Dialog, {
          class: 'cui-dialog-l',
          closeOnOutsideClick: false,
          isOpen: isOpen,
          onClose: () => isOpen = false,
          title: this.getText("LT00000072", "Site Group"),
          content: m(Content, { onChange })
        })
      ]
    }
  }
}
